import { useEffect, useRef } from 'react';
import { HelpButton } from './HelpButton';
import { TourPicker } from './TourPicker';
import { useOnboarding } from './useOnboarding';

/**
 * Mounts the always-on onboarding surfaces (help FAB + picker dialog) and
 * auto-starts the generic tour for first-time anonymous visitors.
 *
 * Signed-in users get the OnboardingIntroDialog (already mounted in App.tsx).
 */
export function OnboardingMount() {
  const { shouldShowGenericTour, isActive, startTour } = useOnboarding();
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    if (shouldShowGenericTour && !isActive) {
      startedRef.current = true;
      // Delay so the app has a chance to mount data-guide targets
      const t = setTimeout(() => startTour('generic'), 400);
      return () => clearTimeout(t);
    }
  }, [shouldShowGenericTour, isActive, startTour]);

  return (
    <>
      <HelpButton />
      <TourPicker />
    </>
  );
}
